import { FormEvent, useState } from "react";

interface ReplyFormProps {
  onSubmit: (content: string) => void;
}

export default function ReplyForm({ onSubmit }: ReplyFormProps) {
  const [content, setContent] = useState("");
  const [notice, setNotice] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = content.trim();
    if (!value) {
      setNotice("说点什么再发送吧，一句话也可以。");
      return;
    }
    if (value.length > 500) {
      setNotice("回帖最多 500 字，精简一下再发。");
      return;
    }
    onSubmit(value);
    setContent("");
    setNotice("回帖已发布，谢谢你愿意参与讨论。");
  };

  return (
    <form onSubmit={handleSubmit} className="mt-5">
      <div className="rounded-lg border border-background-300 bg-background-50 p-4">
        <label htmlFor="reply-content" className="text-sm font-medium text-foreground-950">
          我也来说两句
        </label>
        <textarea
          id="reply-content"
          name="reply"
          value={content}
          maxLength={500}
          onChange={(event) => {
            setContent(event.target.value);
            if (notice) setNotice("");
          }}
          rows={4}
          placeholder="友善表达你的看法，先聊感受再谈观点…"
          className="mt-3 w-full resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm leading-relaxed text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
        />
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
          <span className="text-xs text-foreground-400">{content.length} / 500</span>
          <button
            type="submit"
            className="flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-line" />
            发布回帖
          </button>
        </div>
      </div>
      {notice && (
        <p className="mt-2.5 flex items-center gap-1.5 text-xs text-primary-700">
          <i className="ri-information-line" />
          {notice}
        </p>
      )}
    </form>
  );
}